module.exports = __webpack_public_path__ + "static/media/imgNosotros2.27fe14fc.png";